import styled from 'styled-components';

export const StatsContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-right: -8px;
  margin-bottom: 16px;
`;

export const StatValue = styled.div`
  font-size: 36px;
  color: #666666;
  line-height: 1.2;
`;

export const StatLabel = styled.div`
  font-size: 14px;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const StatBox = styled.div`
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 14px;
  text-align: center;
  min-width: 120px;
  max-width: 200px;
  flex: 1;
  margin-right: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const MessageText = styled.div`
  font-size: 16px;
  margin-top: 16px;
  max-width: 400px;
  text-align: center;
`;

export const HeaderText = styled.div`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 8px;
  text-align: ${p => p.align || 'left'};
`;

export const FileHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-bottom: 16px;
  width: 100%;
`;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DownloadLink = styled.button`
  background: none;
  border: none;
  color: #2196f3;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
  padding: 8px;
  text-decoration: underline;

  &:hover {
    opacity: ${({ disabled }) => (disabled ? 0.7 : 0.8)};
  }
`;

export const ErrorBoxSpace = styled.div`
  margin-bottom: 16px;
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  transition: max-height 0.3s ease-in-out;
  max-height: ${p => (p.hasError ? '300px' : '0')};
  margin-top: ${p => (p.hasError ? '0' : '30px')};
  overflow: hidden;
`;

export const ErrorBox = styled.div`
  background-color: #fff1f0;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  display: flex;
  justify-content: space-between;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

export const DownloadReportContainer = styled.div`
  border-radius: 8px;
  padding: 10px 20px;
  background: white;
  border: 1px solid #f0f0f0;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
